{#if fields.isBurgerMenu}
  <div class="menu-trigger cursor-pointer w-max" on:click={handleTrigger}>
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      {#if fields.triggerClose && isExpanded}
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      {:else}
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
      {/if}
    </svg>
  </div>
{/if}

<nav class="{fields.isBurgerMenu ? 'menu-content' : ''} {menuClass} {sizeClass} {cssClass} relative" class:active={isExpanded} style="background: { isExpanded ? backgroundColor : ''}">
  <div class="menu-container {fields.isBurgerMenu ? 'menu-overflow' : ''}">
    {#if isExpanded && !fields.triggerClose}
      <div class="menu__close-button" on:click={handleClose}>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
    {/if}
    {#key $url}
      <ul on:mouseleave={() => closeItem(isChild)} class="menu-plugin-items {!isChild ? 'menu-plugin-items--root' : 'menu-plugin-child-items'}">
        {#if items.length || childItems.length}
          {#each menuItems as item (item.id)}
            <!-- only show child item if is expanded (if it's a burger menu etc)-->
            {#if accordionChild || useAccordions}
              {#if displayItem(item)}
                {#if (isChild && item.isExpanded) || !isChild}
                  <li in:fly|local={{ duration: 300, y: 50 }} class={itemClasses(item)} class:menu-plugin__expanded={item.isExpanded}>
                    <div class="child-menu-accordion ml-4 flex mt-4 justify-between gap-3">
                      <div class="link ml-4">
                        <!-- svelte-ignore a11y-mouse-events-have-key-events -->
                        <a on:mouseover={(e) => hoverExpand(e, item, 'link')} on:click={(e) => expandItem(e, item, 'link')} href={item?.href} target={item?.target ? '_blank' : '_self'}>{item?.label}</a>
                      </div>
                      <div class="expand">
                        <!-- show expand trigger if you want to use accordions -->
                        {#if !isChild && fields.useAccordions && item?.items.length && fields.selectedIcon}
                          <div class="expand-trigger cursor-pointer" on:click={(e) => expandItem(e, item)}>
                            {#if item.isExpanded}
                              {@html fields.selectedIcon.svgMinimise}
                            {:else}
                              {@html fields.selectedIcon.svgExpand}
                            {/if}
                          </div>
                        {/if}
                      </div>
                    </div>
                    {#if Array.isArray(item?.items) && item?.items.length}
                      <svelte:self childItems={item?.items} isChild accordionChild />
                    {/if}
                  </li>
                {/if}
              {/if}
              <!-- if it's not using accordions then don't use them -->
            {:else}
              {#if displayItem(item)}
                <li class={itemClasses(item)}>
                  <a href={item?.href} target={item?.target ? '_blank' : '_self'}>{item?.label}</a>
                  {#if Array.isArray(item?.items) && item?.items.length}
                    <svelte:self childItems={item?.items} isChild />
                  {/if}
                </li>
              {/if}
            {/if}
          {/each}
        {/if}
      </ul>
    {/key}
  </div>
</nav>

<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};
  export const classNames = ['plugin__menu', 'cms-tw']
  export const Components = {
    load: [
      'core/ui/utilities/OutsideClick',
    ],
  }
</script>

<script>
  import { getContext, onMount } from 'svelte'
  import { fly } from 'svelte/transition'
  export let fields = {}
  export let isChild = false
  export let childItems = []
  export let accordionChild = false

  let menuItems = []
  let isExpanded = false

  const platform = getContext('platform')
  const { url } = platform.router
  const hasMenu = platform.api.core.store('ecom.hasMenu')

  const isLoggedIn = platform.api.core.isLoggedIn()

  let sizeClass = handleSizeClass()
  let menuClass = handlePositionClass()

  $: cssClass = fields.customCSS || ''
  $: backgroundColor = fields.backgroundColor

  platform.router.before(() => {
    handleClose()
  })

  let items = []

  $: if (fields) {
    loadMenuItems()
  }

  $: useAccordions = fields.useAccordions || false
  $: accordionHover = fields.accordionHover || false
  $: menuItems = items.length ? items : childItems

  $: if (fields?.appearsFrom) {
    menuClass = handlePositionClass()
  }

  $: if (fields?.menuSize) {
    sizeClass = handleSizeClass()
  }

  $: if (IS_BROWSER && isExpanded) {
    document.body.classList.add('cms-disable-scroll')
  }

  onMount(async () => {
    if (!fields?.id) {
      items = fields.items || []

      return
    }
    await loadMenuItems()
  })

  async function loadMenuItems () {
    if (!Object.keys(fields).length) {
      return
    }

    if (!$hasMenu || !items?.length) {
      try {
        const entity = await platform.api.cms.entities.find({
          where: `bucket.name = ? AND entity.name = ?`,
          whereArgs: ['navigationPlugins', fields.id],
        })

        items = JSON.parse(entity.payload).items
        $hasMenu = true
      } catch (error) {
        console.error(error)
      }
    }
  }

  function displayItem (item) {
    if (!item) {
      return false
    }

    if (item.requireLogin && !isLoggedIn) {
      return false
    }

    if (!Array.isArray(item.scopes) || !item.scopes.length) {
      return true
    }

    return platform.api.core.hasScope(...item.scopes)
  }

  function itemClasses (item) {
    const classes = []

    if (item?.id) {
      classes.push(`menu-plugin__item-${item?.id.split('-').shift()}`)
    }

    if (item?.href === platform.router.pathname) {
      classes.push('menu-plugin__active')
    }

    if (item?.label !== '') {
      classes.push(
        'menu-plugin__' + item?.label
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9-]+/gi, '')
          .replace(/-+/g, '-')
          .toLowerCase(),
      )
      classes.push('menu-plugin__top')
    }

    if (Array.isArray(item?.items) && item?.items.length) {
      classes.push('menu-plugin__parent')
    }

    if (hasActiveChild(item?.items)) {
      classes.push('menu-plugin__child-active')
    }

    return classes.join(' ')
  }

  function hasActiveChild (items) {
    if (!Array.isArray(items)) {
      return false
    }

    for (let i = 0; i < items.length; ++i) {
      const item = items[i]

      if (item?.href === platform.router.pathname) {
        return true
      }

      if (item?.items.length) {
        return hasActiveChild(item?.items)
      }
    }

    return false
  }

  function handleTrigger () {
    isExpanded = !isExpanded
    document.body.classList.remove('cms-disable-scroll')
  }

  function handleClose () {
    document.body.classList.remove('cms-disable-scroll')

    function minimiseItems (items) {
      if (!items.length) {
        return
      }

      for (const item of items) {
        item.isExpanded = false

        minimiseItems(item.items)
      }
    }

    minimiseItems(items)

    isExpanded = false
    items = items
  }

  function handleSizeClass () {
    if (!fields.isBurgerMenu) {
      return ''
    }
    switch (fields.menuSize) {
      case 'small':
        return 'menu-small'
      case 'medium':
        return 'menu-medium'
      case 'full':
        return 'menu-full'
      default:
        return ''
    }
  }

  function hoverExpand (e, item, type) {
    if (!accordionHover) {
      return
    }

    expandItem(e, item, type)
  }

  function expandItem (e, item, type) {
    if (type === 'link' && !fields.parentsLink) {
      e.preventDefault()
    }
    // close all the other menus first
    for (const menuItem of items) {
      // if it's a different menu from the clicked
      // then close it
      if (menuItem !== item) {
        menuItem.isExpanded = false
        for (const child of menuItem.items) {
          child.isExpanded = false
        }
      // if it's already expanded then close it
      } else {
        if (menuItem.isExpanded) {
          menuItem.isExpanded = false
          for (const child of menuItem.items) {
            child.isExpanded = false
          }
        // if it's not expanded open it
        } else {
          menuItem.isExpanded = true
          for (const child of menuItem.items) {
            child.isExpanded = true
          }
        }
      }
    }

    menuItems = menuItems
  }

  function closeItem (isChild) {
    if (isChild || !accordionHover) {
      return
    }

    for (const menuItem of items) {
      menuItem.isExpanded = false

      for (const child of menuItem.items) {
        child.isExpanded = false
      }
    }

    menuItems = menuItems
  }

  function handlePositionClass () {
    if (!fields.isBurgerMenu) {
      return ''
    }
    switch (fields.appearsFrom) {
      case 'top':
        return 'menu-top'
      case 'left':
        return 'menu-left'
      case 'right':
        return 'menu-right'
      case 'bottom':
        return 'menu-bottom'
      default:
        return ''
    }
  }
</script>

<style>
  .menu-content {
    padding:100px 50px;
    z-index: 10;
    position:fixed;
    opacity:0;
    transition: .3s ease;
  }
  .menu-overflow {
    overflow-y: auto;
  }
  .menu__close-button {
    width:30px;
    height:30px;
    cursor:pointer;
    margin-left:auto;
    top: 50px;
    right:50px;
  }

  .menu-full {
    width: 100%;
    height: 100%;
  }

  .menu-small {
    width: 30%;
    height:100%;
  }

  .menu-medium {
    width: 50%;
    height:100%;
  }

  .menu-right {
    top:0;
    right:0;
    opacity:1;
    transform: translateX(100%);
  }

  .menu-right.active {
    transform: translateX(0);
  }

  .menu-left {
    top:0;
    left:0;
    opacity:1;
    transform: translateX(-100%);
  }

  .menu-left.active {
    transform: translateX(0);
  }

  .menu-top {
    top:0;
    opacity:1;
    transform: translateY(-100%);
  }

  .menu-top.active {
    transform: translateY(0);
  }

  .menu-bottom {
    bottom:0;
    opacity:1;
    transform: translateY(100%);
  }

  .menu-bottom.active {
    transform: translateY(0);
  }

  .menu-plugin-child-items {
    margin-left: 1.5rem;
  }

</style>
